/**
 * Button Effects Utility
 * 
 * This file contains utility functions for adding visual effects to buttons.
 */

/**
 * Adds a ripple effect to a button when clicked
 * @param {Event} event - The click event
 */
export const addRippleEffect = (event) => {
  const button = event.currentTarget;
  
  // Create ripple element
  const ripple = document.createElement('span');
  ripple.classList.add('ripple');
  
  // Get button dimensions
  const rect = button.getBoundingClientRect();
  
  // Calculate ripple position
  const size = Math.max(rect.width, rect.height);
  const x = event.clientX - rect.left - size / 2;
  const y = event.clientY - rect.top - size / 2;
  
  // Set ripple styles
  ripple.style.width = ripple.style.height = `${size}px`;
  ripple.style.left = `${x}px`;
  ripple.style.top = `${y}px`;
  
  // Add ripple to button
  button.appendChild(ripple);
  
  // Remove ripple after animation completes
  setTimeout(() => {
    ripple.remove();
  }, 600);
};

/**
 * Adds ripple effect to all buttons with the 'ripple-effect' class
 */
export const initializeRippleButtons = () => {
  const rippleButtons = document.querySelectorAll('.ripple-effect');
  
  rippleButtons.forEach(button => {
    button.addEventListener('click', addRippleEffect);
  });
  
  // Return cleanup function
  return () => {
    rippleButtons.forEach(button => {
      button.removeEventListener('click', addRippleEffect);
    });
  };
}; 